import { BlobPicture } from '@london-life/ui/components/blob-picture';
import { api } from './api';

// A picture the API serves (an advert's, a Gist photo): fetched with the player's session and kept, so it is
// never fetched twice.
const files = new Map<string, Promise<Blob | null>>();
export function apiPictureFile(path: string): Promise<Blob | null> {
  let kept = files.get(path);
  if (!kept) {
    kept = api.picture(path).catch(() => {
      files.delete(path);
      return null;
    });
    files.set(path, kept);
  }
  return kept;
}

// one of those pictures, shown while it is on the screen
export function ApiPicture({ path, alt, className }: { path: string; alt: string; className?: string }) {
  return <BlobPicture id={path} load={() => apiPictureFile(path)} alt={alt} className={className} />;
}
